/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UploadPresignedUrlDto } from '../../models/upload-presigned-url-dto';
import { UploadPresignedUrlResponse } from '../../models/upload-presigned-url-response';

export interface PresignedUrlForUpload$Params {
  body: UploadPresignedUrlDto;
}

export function presignedUrlForUpload(
  http: HttpClient,
  rootUrl: string,
  params: PresignedUrlForUpload$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<UploadPresignedUrlResponse>> {
  const rb = new RequestBuilder(rootUrl, presignedUrlForUpload.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UploadPresignedUrlResponse>;
    })
  );
}

presignedUrlForUpload.PATH = '/v1/presigned/upload';
